import React from "react";
import { Grid } from "@material-ui/core";

import { ProductCard } from "../components";
import { findSortFromMenu } from "../helpers";
import { FABandBackdrop } from ".";

export default (props) => {
  const { menu, favorite } = props;
  if (!menu || !favorite) return null;
  console.log(favorite, typeof favorite);
  return (
    <FABandBackdrop>
      <Grid container spacing={3}>
        {favorite.map((name) => {
          const menuPosition = findSortFromMenu(name, menu);
          if (menuPosition) {
            const { first, second } = menuPosition;
            let item = menu[first][second][name];
            return (
              <Grid key={name} item xs={12} md={6} lg={4}>
                <ProductCard {...item} name={name} />
              </Grid>
            );
          }
        })}
      </Grid>
    </FABandBackdrop>
  );
};
